export enum WavFormatKeys {
    Initialize = "Initialize",
    EncodeChunk = "EncodeChunk",
    EncodeFile = "EncodeFile"
};